/**
 * Helper function to get material color
 */
export const getMaterialColor = (material: string): string => {
  const colorMap: Record<string, string> = {
    gold: '#d4af37',
    metal: '#9aa3ab',
    amalgam: '#9aa3ab',
    ceramic: '#9ecfeb',
    zirconia: '#cee899',
    composite: '#c2aef8',
    pfm: '#6f8fa6',
    pfz: '#7fb3a8',
    temporary: '#E7D9CB',
  }
  return colorMap[material.toLowerCase()] || '#9ecfeb'
}

/**
 * Helper function to get chart color for materials (colors used in the actual chart visualization)
 */
export const getChartMaterialColor = (
  material: string,
  conditionType?: string,
): string => {
  const materialLower = material.toLowerCase()

  // Filling colors
  if (conditionType === 'filling') {
    const fillingColors: Record<string, string> = {
      ceramic: '#9ecfeb',
      composite: '#c2aef8',
      gold: '#d4af37',
      amalgam: '#9aa3ab',
      temporary: '#E7D9CB',
    }
    return fillingColors[materialLower] || '#9ecfeb'
  }

  // Inlay colors
  if (conditionType === 'inlay') {
    const inlayColors: Record<string, string> = {
      gold: '#d4af37',
      zirconia: '#cee899',
      ceramic: '#9ecfeb',
    }
    return inlayColors[materialLower] || '#9ecfeb'
  }

  // Onlay colors
  if (conditionType === 'onlay') {
    const onlayColors: Record<string, string> = {
      gold: '#d4af37',
      zirconia: '#cee899',
      ceramic: '#9ecfeb',
    }
    return onlayColors[materialLower] || '#9ecfeb'
  }

  // Crown colors
  if (conditionType === 'crown') {
    const crownColors: Record<string, string> = {
      zirconia: '#cee899',
      pfm: '#6f8fa6',
      pfz: '#7fb3a8',
      metal: '#9aa3ab',
      ceramic: '#9ecfeb',
    }
    return crownColors[materialLower] || '#9ecfeb'
  }

  // Bridge colors (same as crown)
  if (conditionType === 'bridge') {
    const bridgeColors: Record<string, string> = {
      zirconia: '#cee899',
      pfm: '#6f8fa6',
      pfz: '#7fb3a8',
      metal: '#9aa3ab',
      ceramic: '#9ecfeb',
    }
    return bridgeColors[materialLower] || '#9ecfeb'
  }

  if (conditionType === 'veneer') {
    const veneerColors: Record<string, string> = {
      ceramic: '#9ecfeb',
      composite: '#c2aef8',
      zirconia: '#cee899',
    }
    return veneerColors[materialLower] || '#9ecfeb'
  }

  // Default fallback
  return '#9ecfeb'
}

/**
 * Helper function to get contrasting text color (black or white)
 */
export const getContrastColor = (backgroundColor: string): string => {
  // Convert hex to RGB
  const hex = backgroundColor.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

  // Return black for light backgrounds, white for dark backgrounds
  return luminance > 0.5 ? '#000000' : '#FFFFFF'
}
